import React from "react";
import "./TimelineStyles.css";
import tail from "../../Images/Timeline/tl-tail.png";
import { HiExternalLink } from "react-icons/hi";

export default function Timeline() {
  return (
    <>
      <div className="tl-wrapper">
        <div className="tl-title">EXPERIENCE</div>
        <div className="tl-window">
          <div className="dates">
            <h1 className="time-spec">current</h1>
            <h1 className="time-spec">jan-june 2022</h1>
            <h1 className="time-spec">Graduated</h1>
          </div>

          <img className="tl-img" src={tail}></img>
          <div className="tl-content">
            <h1 className="exp-head">
              Rockstar Games
              <a
                href="https://www.rockstargames.com/careers/offices/rockstar-india"
                target="_blank"
              >
                <HiExternalLink />
              </a>
            </h1>
            <h4 className="exp-sub">Associate online services qa</h4>{" "}
            <p className="exp-desc">
              <p>
                - Provided Quality Assurance on the services, updates, live
                events on the associated Triple A titles.
              </p>
              <p>
                - Coworked with the Indian OSQA team Alongside the Licoln team
                with a rapid iteration and growth.
              </p>
              <p>
                - Worked with PC and both current and Last Gen Consoles for
                testing and further OSQA requirements.
              </p>
            </p>
            <h1 className="exp-head">
              Jambox Games
              <a href="https://jambox.games/" target="_blank">
                <HiExternalLink />
              </a>
            </h1>
            <h4 className="exp-sub">Game designer and Unity Programmer</h4>{" "}
            <p className="exp-desc">
              <p>
                -Pitched multiple game ideas to product head and got feedback and
                design critique, and designed the core gameplay loop of the
                latest game.
              </p>
              <p>
                -Worked on a flexible content generation system that allowed for
                a 100% increase in content creation efficiency for our game.
              </p>
              <p>
                -Personally went through every stage of SDLC for two company
                products.
              </p>
              <p>
                -Wrote unit tests, helper classes and performed regression
                testing on many of our flagship tools. Performed Regression,
                Smoke and Various other types of testing.
              </p>
            </p>
            <h1 className="exp-head">Bachelors' in IT</h1>
            <h4 className="exp-sub">
              <a href="https://jaipur.manipal.edu/" target="_blank">
                Manipal University Jaipur
              </a>
            </h4>{" "}
            <p className="exp-desc"></p>
          </div>
        </div>
        <div className="tl-seperator"> </div>
      </div>
    </>
  );
}
